import React from "react";
import { Helmet } from "react-helmet";

export default function GurukulERPPage() {

  const features = [
    "Student Management System",
    "Online Fee Management",
    "Attendance Tracking",
    "Exam & Result Management",
    "Notice & Announcement System",
    "Transport Management",
    "Staff & Payroll Management",
    "Library Management System",
  ];

  const modules = [
    {
      title: "Student Management",
      desc: "Manage admissions, student profiles, attendance, academic records, and class activities from a centralized dashboard.",
    },

    {
      title: "Fee Management",
      desc: "Automate fee collection, invoices, payment tracking, due reminders, and financial reporting.",
    },

    {
      title: "Exam Management",
      desc: "Create exams, manage marks, generate report cards, and track academic performance efficiently.",
    },

    {
      title: "Notice Management",
      desc: "Share school notices, announcements, circulars, and important updates digitally in real time.",
    },

    {
      title: "Staff Management",
      desc: "Manage teachers, payroll, leave requests, staff attendance, and HR operations from one system.",
    },

    {
      title: "Transport Management",
      desc: "Track routes, vehicles, drivers, and student transportation operations efficiently.",
    },
  ];

  const benefits = [
    "Cloud-Based School ERP",
    "Mobile Friendly Dashboard",
    "Multi-User Access System",
    "Secure Data Management",
    "Fast Performance & Scalability",
    "Custom School ERP Solutions",
  ];

  const faqs = [
    {
      q: "What is GuruKul School ERP?",
      a: "GuruKul School ERP is a complete school management software developed by SoftCoders for managing admissions, attendance, fees, exams, staff, and school administration.",
    },

    {
      q: "Who can use GuruKul School ERP?",
      a: "Schools, colleges, coaching institutes, and educational organizations can use GuruKul School ERP to automate academic and administrative operations.",
    },

    {
      q: "Is GuruKul School ERP cloud-based?",
      a: "Yes. GuruKul School ERP is a cloud-based school management system accessible from desktop and mobile devices.",
    },

    {
      q: "Does GuruKul School ERP support online fee payment?",
      a: "Yes. The software supports online fee collection, invoice management, payment tracking, and financial reporting.",
    },
  ];

  return (

    <div className="bg-[#070B1A] text-white overflow-hidden">

      
  <Helmet>

    {/* PRIMARY SEO */}
    <title>
      GuruKul School ERP Software | School Management System | SoftCoders
    </title>

    <meta
      name="description"
      content="GuruKul School ERP is a cloud-based school management software developed by SoftCoders for managing admissions, attendance, fees, exams, staff, transport, library operations, and school administration from a centralized dashboard."
    />

    <meta
      name="keywords"
      content="
      school erp software,
      school management software,
      cloud based school erp,
      school management system,
      online school erp software,
      school erp india,
      school software solution,
      student management system,
      attendance management software,
      online fee management system,
      exam management software,
      school administration software,
      education erp software,
      school automation software,
      school crm software,
      school fee management software,
      school attendance software,
      school mobile app,
      school database management,
      school staff management system,
      transport management software,
      library management system,
      school payroll software,
      educational institution software,
      school software company,
      custom school erp,
      smart school software,
      digital school management,
      school management app,
      best school erp software,
      erp for schools,
      school management platform,
      online education software,
      school digital transformation,
      educational software development,
      school software india,
      student information system,
      school management dashboard,
      school automation platform,
      guruKul school erp
      "
    />

    <meta name="author" content="SoftCoders" />
    <meta name="robots" content="index, follow" />
    <meta name="language" content="English" />
    <meta name="revisit-after" content="2 days" />

    {/* CANONICAL */}
    <link
      rel="canonical"
      href="https://softcoders.in/gurukul-school-erp"
    />

    {/* OPEN GRAPH */}
    <meta
      property="og:title"
      content="GuruKul School ERP Software | School Management System | SoftCoders"
    />

    <meta
      property="og:description"
      content="Cloud-based school ERP software for managing admissions, attendance, fees, exams, staff, transport, and school administration."
    />

    <meta
      property="og:url"
      content="https://softcoders.in/gurukul-school-erp"
    />

    <meta property="og:type" content="website" />

    <meta
      property="og:image"
      content="https://softcoders.in/og-gurukul-erp.jpg"
    />

    {/* TWITTER SEO */}
    <meta name="twitter:card" content="summary_large_image" />

    <meta
      name="twitter:title"
      content="GuruKul School ERP Software | School Management System | SoftCoders"
    />

    <meta
      name="twitter:description"
      content="Complete school ERP software for admissions, attendance, fees, exams, payroll, transport, and administration management."
    />

    <meta
      name="twitter:image"
      content="https://softcoders.in/og-gurukul-erp.jpg"
    />

    {/* GEO SEO */}
    <meta name="geo.region" content="IN" />
    <meta name="geo.country" content="India" />

    {/* MOBILE SEO */}
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1"
    />

    <meta
      name="theme-color"
      content="#070B1A"
    />

    {/* PRODUCT SCHEMA */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        name: "GuruKul School ERP",
        applicationCategory: "BusinessApplication",
        operatingSystem: "Web-based",
        url: "https://softcoders.in/gurukul-school-erp",
        image: "https://softcoders.in/og-gurukul-erp.jpg",
        description:
          "GuruKul School ERP is a cloud-based school management software developed by SoftCoders for managing admissions, attendance, fees, exams, staff, transport, and administration.",
        brand: {
          "@type": "Brand",
          name: "SoftCoders"
        },
        offers: {
          "@type": "Offer",
          price: "0",
          priceCurrency: "INR"
        },
        featureList: [
          "Student Management System",
          "Online Fee Management",
          "Attendance Tracking",
          "Exam Management",
          "Transport Management",
          "Staff Management",
          "Library Management",
          "Cloud-Based Dashboard"
        ]
      })}
    </script>

    {/* ORGANIZATION SCHEMA */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "SoftCoders",
        url: "https://softcoders.in",
        logo: "https://softcoders.in/logo.png",
        sameAs: [
          "https://www.facebook.com/",
          "https://www.instagram.com/",
          "https://www.linkedin.com/"
        ]
      })}
    </script>

    {/* FAQ SCHEMA */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "What is GuruKul School ERP?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "GuruKul School ERP is a complete school management software developed by SoftCoders for managing admissions, attendance, fees, exams, staff, and school administration."
            }
          },
          {
            "@type": "Question",
            name: "Who can use GuruKul School ERP?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Schools, colleges, coaching institutes, and educational organizations can use GuruKul School ERP to automate academic and administrative operations."
            }
          },
          {
            "@type": "Question",
            name: "Is GuruKul School ERP cloud-based?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes. GuruKul School ERP is a cloud-based school management system accessible from desktop and mobile devices."
            }
          },
          {
            "@type": "Question",
            name: "Does GuruKul School ERP support online fee payment?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Yes. The software supports online fee collection, invoice management, payment tracking, and financial reporting."
            }
          }
        ]
      })}
    </script>

  </Helmet>

      {/* HERO */}
      <section className="relative overflow-hidden border-b border-white/5 py-28">

        {/* GRID */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `
              linear-gradient(rgba(99,102,241,.4) 1px, transparent 1px),
              linear-gradient(90deg, rgba(99,102,241,.4) 1px, transparent 1px)
            `,
            backgroundSize: "80px 80px",
          }}
        />

        {/* GLOW */}
        <div className="absolute top-[-200px] right-[-200px] w-[600px] h-[600px] rounded-full bg-indigo-600/20 blur-3xl"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">

          <div className="max-w-5xl">

            <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-indigo-500/20 bg-indigo-500/10 text-indigo-300 text-sm font-medium">

              <div className="w-2 h-2 rounded-full bg-indigo-400"></div>

              School ERP Software Solution

            </div>

            <h1 className="text-5xl lg:text-7xl font-black leading-[0.9] mt-8">

              GuruKul
              <span className="block text-indigo-400 mt-2">
                School ERP
              </span>

            </h1>

            <p className="text-slate-400 text-lg leading-8 mt-8 max-w-4xl">

              GuruKul School ERP is a cloud-based school management software
              developed by SoftCoders to simplify admissions,
              attendance tracking,
              fee management,
              examinations,
              staff management,
              notice management,
              and school administration.

            </p>

            {/* BUTTONS */}
            <div className="flex flex-wrap gap-5 mt-10">

              <a
    href="https://www.gurukulerp.in/"
 className="bg-indigo-600 hover:bg-indigo-500 transition-all duration-300 px-8 py-4 rounded-2xl font-bold shadow-[0_15px_40px_rgba(99,102,241,0.25)]">
                Request Demo
              </a>

              <a
    href="/contact"
 className="border border-white/10 hover:border-indigo-500/40 px-8 py-4 rounded-2xl text-slate-300 transition-all duration-300">
                Contact SoftCoders
              </a>

            </div>

            {/* STATS */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">

              {[
                ["100+", "School Modules"],
                ["24/7", "Cloud Access"],
                ["99.9%", "System Uptime"],
                ["Multi", "User Roles"],
              ].map(([num, label], i) => (

                <div key={i}>

                  <div className="text-4xl font-black text-indigo-400">
                    {num}
                  </div>

                  <div className="text-slate-500 mt-2">
                    {label}
                  </div>

                </div>

              ))}

            </div>

          </div>

        </div>

      </section>

      {/* CONTENT */}
      <section className="py-28 border-b border-white/5">

        <div className="max-w-5xl mx-auto px-6 lg:px-10">

          <h2 className="text-5xl font-black leading-tight">

            Complete School Management Software

          </h2>

          <div className="space-y-8 text-slate-400 text-lg leading-9 mt-10">

            <p>

              GuruKul School ERP is a complete school management system
              designed for schools, colleges, and educational institutions
              looking to automate academic and administrative operations.

            </p>

            <p>

              The software helps schools manage admissions,
              student records,
              attendance,
              fees,
              exams,
              transport,
              library operations,
              and notice management
              from a centralized dashboard.

            </p>

            <p>

              GuruKul School ERP improves operational efficiency,
              reduces manual work,
              simplifies data management,
              and enables educational institutions
              to manage daily operations more effectively.

            </p>

            <p>

              The platform is optimized for performance,
              security,
              scalability,
              and mobile accessibility,
              making it suitable for modern educational institutions.

            </p>

          </div>

        </div>

      </section>

      {/* FEATURES */}
      <section className="py-28 border-b border-white/5">

        <div className="max-w-7xl mx-auto px-6 lg:px-10">

          <div className="text-center max-w-3xl mx-auto">

            <div className="text-indigo-400 uppercase tracking-[0.2em] text-sm font-semibold">
              FEATURES
            </div>

            <h2 className="text-5xl font-black mt-6">

              GuruKul ERP Features

            </h2>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-20">

            {features.map((feature, i) => (

              <div
                key={i}
                className="
                  rounded-3xl
                  border
                  border-white/10
                  bg-[#0E142B]
                  p-8
                  hover:border-indigo-500/30
                  transition-all
                  duration-300
                "
              >

                <div className="text-indigo-400 text-2xl mb-6">
                  →
                </div>

                <h3 className="text-2xl font-bold">

                  {feature}

                </h3>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* MODULES */}
      <section className="relative py-28 border-b border-white/5 overflow-hidden">

        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-indigo-500/10 blur-3xl rounded-full"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">

          <div className="max-w-4xl">

            <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-indigo-500/20 bg-indigo-500/10 text-indigo-300 text-sm font-medium">

              <div className="w-2 h-2 rounded-full bg-indigo-400"></div>

              ERP Modules

            </div>

            <h2 className="text-5xl lg:text-6xl font-black leading-[0.95] mt-8">

              Powerful Modules
              <span className="block text-indigo-400 mt-2">
                Built for Schools
              </span>

            </h2>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-20">

            {modules.map((module, i) => (

              <div
                key={i}
                className="
                  group
                  relative
                  overflow-hidden
                  rounded-[32px]
                  border
                  border-white/10
                  bg-[#0E142B]
                  p-8
                  hover:border-indigo-500/30
                  hover:-translate-y-2
                  transition-all
                  duration-500
                "
              >

                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-500 bg-gradient-to-br from-indigo-500/[0.08] to-transparent"></div>

                <div className="relative z-10">

                  <h3 className="text-2xl font-black group-hover:text-indigo-300 transition-all duration-300">

                    {module.title}

                  </h3>

                  <p className="text-slate-400 leading-8 mt-5">

                    {module.desc}

                  </p>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* BENEFITS */}
      <section className="py-28 border-b border-white/5">

        <div className="max-w-6xl mx-auto px-6 lg:px-10">

          <div className="text-center">

            <div className="text-indigo-400 uppercase tracking-[0.2em] text-sm font-semibold">
              BENEFITS
            </div>

            <h2 className="text-5xl font-black mt-6">

              Why Schools Choose GuruKul ERP

            </h2>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-20">

            {benefits.map((item, i) => (

              <div
                key={i}
                className="
                  rounded-3xl
                  border
                  border-white/10
                  bg-[#0E142B]
                  p-8
                  text-center
                "
              >

                <div className="text-indigo-400 text-3xl mb-6">
                  ✓
                </div>

                <h3 className="text-2xl font-bold">

                  {item}

                </h3>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* FAQ */}
      <section className="py-28 border-b border-white/5">

        <div className="max-w-4xl mx-auto px-6 lg:px-10">

          <div className="text-center mb-20">

            <div className="text-indigo-400 uppercase tracking-[0.2em] text-sm font-semibold">
              FAQ
            </div>

            <h2 className="text-5xl font-black mt-6">

              Frequently Asked Questions

            </h2>

          </div>

          <div className="space-y-6">

            {faqs.map((faq, i) => (

              <div
                key={i}
                className="
                  rounded-3xl
                  border
                  border-white/10
                  bg-[#0E142B]
                  p-8
                "
              >

                <h3 className="text-2xl font-bold">

                  {faq.q}

                </h3>

                <p className="text-slate-400 leading-8 mt-4">

                  {faq.a}

                </p>

              </div>

            ))}

          </div>

        </div>

      </section>

    </div>

  );
}